import React from "react";
import { FolioLanding } from "../../components/landing/home";

/* The landing page, drawn as a folio.

   The design-comparison bar is gone: the folio was chosen, so it is rendered
   directly, exactly as the note that stood here asked for. The alternates it
   was compared against still live under components/landing/designs/ if one is
   ever wanted back. */

export const HomePage: React.FC = () => <FolioLanding />;
